import fetch from 'cross-fetch';


const CONTACT_FORM_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/2488913/zyzfax/';

export class ZapierService {
  static sendContactForm(data) {
    return fetch(CONTACT_FORM_WEBHOOK, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/ZapierService.js